import React, { createContext, useState, useMemo } from 'react'

export const Context = createContext()

function UnitsTableProvider({ children }) {
  const [units, setUnits] = useState([])
  const [courseSlug, setCourseSlug] = useState(null)
  const [courseType, setCourseType] = useState(null)
  const value = useMemo(
    () => ({
      courseType,
      courseSlug,
      units,
      setCourseType,
      setCourseSlug,
      setUnits,
    }),
    [courseType, courseSlug, units, setCourseType, setCourseSlug, setUnits]
  )

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export default UnitsTableProvider
